var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.60844 5.96125L16.6284 2.95125C20.6784 1.60125 22.8784 3.81125 21.5384 7.86125L18.5284 16.8813C16.5084 22.9513 13.1884 22.9513 11.1684 16.8813L10.2784 14.2013L7.59844 13.3113C1.53844 11.3013 1.53844 7.99125 7.60844 5.96125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6227 12.38C12.4327 12.38 12.2427 12.31 12.0927 12.16C11.9532 12.0189 11.875 11.8284 11.875 11.63C11.875 11.4316 11.9532 11.2411 12.0927 11.1L15.8927 7.28C16.1827 6.99 16.6627 6.99 16.9527 7.28C17.2427 7.57 17.2427 8.05 16.9527 8.34L13.1527 12.16C13.0027 12.3 12.8127 12.38 12.6227 12.38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send2.991e5a332be7059487a93b093a2cab94.svg";
export { ForwardRef as ReactComponent };